<template>
  <div
    data-testid="video-card"
    class="relative flex h-full w-full max-w-[350px] flex-col rounded-lg bg-white shadow-pm md:max-w-[295px]"
  >
    <div class="relative pb-[38.31%]">
      <img
        data-testid="video-card-cover"
        class="absolute left-0 top-0 h-full w-full rounded-t-lg object-cover object-top"
        :src="$cloudinary.resize(coverUrl, 'video-card')"
        alt="card banner"
      />
      <div
        data-testid="video-card-duration"
        class="absolute bottom-3 right-3 rounded bg-s-900 p-1.5 text-xs font-semibold text-white"
      >
        {{ duration }}
      </div>
    </div>
    <div
      class="flex grow flex-col justify-between p-3"
      :class="isActiveIndex ? 'pb-0 xl:pb-3' : 'pb-3'"
    >
      <div>
        <div
          data-testid="video-card-published-date"
          class="mb-2 text-xs font-semibold text-s-700"
        >
          {{ publishedDate }}
        </div>
        <div
          data-testid="video-card-title"
          class="mb-2 line-clamp-2 min-h-12 text-lg font-semibold leading-6"
          :title="title"
        >
          {{ title }}
        </div>
      </div>
      <VideoCardFooter
        class="mt-14"
        :is-authorized="isAuthorized"
        :has-preview="hasPreview"
        :text-button="textButton"
        @play="$emit('play', vimeoId || previewVimeoId)"
      />
    </div>
    <ProgressBar
      v-if="isActiveIndex"
      class="mt-1.5 block xl:hidden"
      duration="10s"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ProgressBar from '~/components/portals/ProgressBar.vue'
import VideoCardFooter from '~/components/portals/VideoCardFooter.vue'
import { useNuxtApp } from '#app'
import type { TVideoWithExtra } from '~/src/types/common'

type TVideoCardProps = TVideoWithExtra & {
  isActiveIndex?: boolean
}

const props = withDefaults(defineProps<TVideoCardProps>(), {
  coverUrl: '',
  isActiveIndex: false,
})

const { $cloudinary } = useNuxtApp()
const isAuthorized = computed(() => !!props.vimeoId)
const hasPreview = computed(() => !!props.previewVimeoId)
const textButton = computed(() => {
  if (isAuthorized.value) return 'Watch Now'
  if (hasPreview.value) return 'Watch Preview'
  return 'Contact Us'
})
</script>
